//SEBI REGISTRATION PAGE
import React, { useState, useRef } from "react";
import validators from "../utils/validators";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { createTheme } from "@mui/material/styles";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import swal from "sweetalert";
import Checkbox from '@mui/material/Checkbox';
import { ListItemText } from "@mui/material";
import { Add, Delete, Edit, Check } from "@material-ui/icons";
import EmailResetModal from "./EmailResetModal";
import SecureLS from "secure-ls";
import Grid from '@mui/material/Grid';
// const domains = {
//     SEBIUSER: "sebi.gov.in",
//     KFIN: "kfintech.com",
//     CAMS: "cams.com",
// };

const useStyles = makeStyles((theme) => ({
    root: {
        height: {
            md: "80%",
            xs: "60%",

        },

        marginTop: 40,
        maxHeight: "80%",
        // marginLeft: "15%",
        width: 800,
        maxWidth: 900,
        borderRadius: 5,
        boxShadow: "0px 3px 15px #BCB0B0",
        background: " #EEEEEE",
        display: "flex",
        justifyContent: "space-evenly",
    },
    textFieldBox: {
        display: "flex",
        flexDirection: "column",
        fontFamily: "Roboto-Bold",
        fontSize: "16px",
        lineHeight: "19px",
        color: "#272782",
        width: "35%",
        marginBottom: "25px",
    },
    rowContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        alignItems: "center",
        width: "100%",
    },
    title: {
        display: "flex",
        alignItems: "center",
        color: "#272782",
        fontWeight: "400",
        height: "45px",
        left: "702px",
        top: "340px",
        fontFamily: "Roboto-Medium",
        fontStyle: "normal",
        fontSize: "36px",
        lineHeight: "42px",
    },

    [theme.breakpoints.down("md")]: {
        root: {
            height: "80%",
            marginTop: 10,
            maxHeight: "80%",
            //marginLeft: "0%",
            width: "100%",
            maxWidth: 900,
            borderRadius: 5,
            boxShadow: "0px 3px 15px #BCB0B0",
            background: " #EEEEEE",
            display: "flex",
            justifyContent: "space-evenly",
        },
    },

    [theme.breakpoints.down("xs")]: {
        root: {
            height: "80%",
            marginTop: 10,
            maxHeight: 650,
            marginLeft: "5%",
            width: "90%",
            maxWidth: 900,
            borderRadius: 5,
            boxShadow: "0px 3px 15px #BCB0B0",
            background: " #EEEEEE",
            display: "flex",
            justifyContent: "space-evenly",
        },
        rowContainer: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
            alignItems: "center",
            width: "100%",
        },
        textFieldBox: {
            display: "flex",
            flexDirection: "column",
            fontFamily: "Roboto-Bold",
            fontSize: "16px",
            lineHeight: "19px",
            color: "#272782",
            width: "75%",
            marginBottom: "25px",
        },
    },
}));

let styles = {
    title: {
        display: "flex",
        alignItems: "center",
        color: "#272782",
        fontWeight: "400",
        height: "45px",
        left: "702px",
        top: "340px",
        fontFamily: "Roboto-Medium",
        fontStyle: "normal",
        fontSize: "36px",
        lineHeight: "42px",
    },
};
const theme = createTheme();
const ls = new SecureLS()

const reportTypeMapping = {
    "Alert Processing": "Alert Processing",
    "CMM": "CMM"
};

const internalReportTypeMapping = {
    "Alert Processing": "Alert Processing",
    "CMM": "CMM"
};

function Sebi_Registration({ handleSubmit, handleUpdate, userDetails }) {

    const initialState = userDetails ? {
        firstName: userDetails.firstName,
        lastName: userDetails.lastName,
        email: userDetails.user.email,
        userType: userDetails.userType,
        division: userDetails.division,
        amcReportDetails: userDetails.app.reports,
        userType: "SEBI",
        accountStatus: "Active",

    } : {
        firstName: "",
        lastName: "",
        email: "",
        userType: "",
        division: "",
        dcName: "none",
        amcReportDetails: [],
        userType: "SEBI",
        accountStatus: "Active",

    };

    const [input, setInput] = useState(initialState);
    // const [loader, setLoader] = useState(false);
    let pmsdata = ls.get("pmsdata")
    const selectionAreaRef = useRef(null);
    function handleChange(event) {
        const { name, value } = event.target;

        setInput((prevInput) => ({
            ...prevInput,
            [name]: name.toLowerCase().includes("email") ? value.toLowerCase() : value,
        }));
    }


    function validateFields(login) {
        let validEmail = validators.validateEmail(login.email)
        if (!validEmail.isValid) swal("", validEmail.message, "warning");
        return (
            validEmail.isValid
        );
    }

    

    const cardStyles = useStyles(theme);
    // const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

    const [selectedAMC, setSelectedAMC] = useState([]);
    // const [selectedAMCCode, setselectedAMCCode] = useState([]);
    const [selectedReport, setSelectedReport] = useState("");
    const [tableData, setTableData] = useState(input.amcReportDetails);
    const [open, setOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(null);


    const handlePlusClick = () => {
        if (selectedAMC.length !== 0 && selectedReport !== "") {
            let newData = { ...tableData };
            if (isEditing && isEditing !== selectedReport) {
                delete newData[isEditing];
            }
            newData[selectedReport] = selectedAMC
            setTableData(newData);
            setSelectedAMC([]);
            setSelectedReport("");
            setIsEditing(null);
        }
    };

    const handleDelete = (indexToDelete) => {
       
        const updatedTableData = { ...tableData };
        if (updatedTableData.hasOwnProperty(indexToDelete)) {
            delete updatedTableData[indexToDelete];
        }

        setTableData(updatedTableData);
        if (isEditing === indexToDelete) setIsEditing(null);
    }

    const handleEdit = (reportName) => {
        setSelectedReport(reportName);
        setSelectedAMC(tableData[reportName]);
        setIsEditing(reportName);

        if (selectionAreaRef.current) {
            selectionAreaRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }
    const handleActionsChange = (val) => {
        if (selectedAMC.some(item => item.code === val.code)) {
            // Remove item if already selected
            setSelectedAMC(selectedAMC.filter(selectedItem => selectedItem.code !== val.code));
        } else {
            // Add item if not selected
            setSelectedAMC([...selectedAMC, val]);
        }
    };

    const handleSelectAll = () => {
        if (selectedAMC.length === pmsdata[0]?.entity.length) {
            // If all are selected, clear selection
            setSelectedAMC([]);
        } else {
            // If not all selected, select ALL items in object format
            let options = pmsdata[0]?.entity.map(val => ({
                "code": val.code,
                "PMS": val.PMS
            }));
            setSelectedAMC(options);
        }
    };

    return (

        <Card className={cardStyles.root}>
            <Box sx={{ marginY: "20px", width: "100%" }}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Box>
                        <Typography component="h1" variant="h4" sx={styles.title}>
                            {userDetails ? "Update SEBI Details" : "SEBI User Registration"}
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            width: "85%",
                            height: "2px",
                            backgroundColor: "#272782",
                            marginTop: "10px",
                            marginBottom: "25px",
                        }}
                    />
                </Box>
                <Box component="form" className="noScroll" sx={{
                    height: {
                        md: "50%",
                        lg: "47%",
                        xl: "59%",
                        xs: "44%",
                        sm: "57%"
                    }, overflow: "scroll", marginBottom: "1rem"
                }}>
                    <Box className={cardStyles.rowContainer}>
                        <Box className={cardStyles.textFieldBox}>
                            <p style={{ margin: "0px" }}>First Name</p>
                            <TextField
                                variant="standard"
                                name="firstName"
                                type="text"
                                placeholder="Enter First Name"
                                value={input.firstName}
                                onChange={handleChange}
                                required
                            />
                        </Box>
                        <Box className={cardStyles.textFieldBox}>
                            <p style={{ margin: "0px" }}>Last Name</p>
                            <FormControl
                                variant="standard"
                                sx={{ my: 0, width: "100%", minWidth: 120 }}
                            >
                                <TextField
                                    variant="standard"
                                    name="lastName"
                                    type="text"
                                    placeholder="Enter Last Name"
                                    value={input.lastName}
                                    onChange={handleChange}
                                    required
                                />
                            </FormControl>
                        </Box>
                    </Box>
                    <Box className={cardStyles.rowContainer}>
                        <Box className={cardStyles.textFieldBox}>

                            <p style={{ margin: "0px" }}>Email</p>
                            <TextField
                                variant="standard"
                                name="email"
                                type="text"
                                placeholder="Enter Email"
                                value={input.email}
                                onChange={handleChange}
                                required
                            />
                        </Box>
                        <Box className={cardStyles.textFieldBox}>
                            <p style={{ margin: "0px" }}>DIVISION</p>
                            <FormControl
                                variant="standard"
                                sx={{ my: 0, width: "100%", minWidth: 120 }}
                            >
                                <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="demo-simple-select-standard"
                                    name="division"
                                    value={input.division}
                                    onChange={handleChange}
                                    label="Division"
                                    placeholder="Select Division"
                                >
                                    <MenuItem value="DC">DC</MenuItem>
                                    <MenuItem value="OFFICER">Officer</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>



                    </Box>

                    <Box ref={selectionAreaRef} className={cardStyles.rowContainer}>
                        <Box className={cardStyles.textFieldBox} sx={{ marginLeft: '45px' }} >
                            <p style={{ margin: "0px" }}>Report Name</p>
                            <FormControl
                                variant="standard"
                                sx={{ my: 0, width: "85%", minWidth: 100 }}
                            >
                                <Select
                                    name="reportName"
                                    value={selectedReport}
                                    onChange={(e) => setSelectedReport(internalReportTypeMapping[e.target.value] || e.target.value)}
                                    label="Report Name"
                                    placeholder="Select Report Name"
                                    labelId="demo-multiple-checkbox-label"
                                    id="demo-multiple-checkbox"
                                    variant="standard"
                                    disabled={["Alert Processing", "CMM"].filter((val) => !Object.keys(tableData).includes(val) || val === isEditing).length === 0}
                                >
                                    {["Alert Processing", "CMM"].filter((val) => !Object.keys(tableData).includes(val) || val === isEditing).map((name) => (
                                        <MenuItem key={name} value={name}>
                                            <ListItemText primary={reportTypeMapping[name]} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                        <Box className={cardStyles.textFieldBox}>
                            <p style={{ margin: "0px" }}>PMS Name</p>
                            <FormControl
                                variant="standard"
                                sx={{
                                    my: 0,
                                    width: "100%",
                                    minWidth: 100,
                                    "& .MuiInputBase-root": {
                                        height: "25px",
                                    },
                                }}
                            >
                                <Select
                                    name="PMSName"
                                    multiple
                                    value={selectedAMC}
                                    label="PMS Name"
                                    placeholder="Select PMS Name"
                                    labelId="demo-multiple-checkbox-label"
                                    id="demo-multiple-checkbox"
                                    renderValue={(selected) => selected.map(item => item.PMS).join(", ")}
                                    variant="standard"
                                    MenuProps={{
                                        PaperProps: {
                                            sx: {
                                                color: "#000000",
                                                "& .MuiMenuItem-root": {
                                                    padding: 1,
                                                },
                                                "& .MuiButtonBase-root.MuiMenuItem-root": {
                                                    height: "2.3rem",
                                                },
                                                maxHeight: "10rem",
                                                maxWidth: "20rem",
                                                overflowY: "auto",
                                                scrollbarWidth: "thin"
                                            },
                                        },
                                    }}
                                >
                                    <MenuItem
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleSelectAll();
                                        }}
                                    >
                                        <Checkbox
                                            checked={selectedAMC.length === pmsdata[0]?.entity?.length}
                                            onChange={() => { }}
                                        />
                                        <ListItemText primary="Select all" />
                                    </MenuItem>
                                    {pmsdata[0]?.entity
                                        ?.sort((a, b) => a.PMS.localeCompare(b.PMS))
                                        .map((val) => (
                                            <MenuItem
                                                key={val.code}
                                                value={val}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleActionsChange(val);
                                                }}
                                            >
                                                <Checkbox
                                                    checked={selectedAMC.some(item => item.code === val.code)}
                                                    onChange={() => { }} // Add empty onChange to prevent warning
                                                />
                                                <ListItemText primary={val.PMS} />
                                            </MenuItem>
                                        ))}
                                </Select>
                            </FormControl>

                        </Box>


                        <Button style={{
                            height: '30px', width: '60px', marginRight: '2.7rem', border: isEditing ? "1px solid #4caf50" : "1px solid #272782", backgroundColor: 'transparent',
                            borderRadius: '180', marginBottom: '12px'
                        }}
                            onClick={handlePlusClick}>
                            {isEditing ? <Check style={{ color: "#4caf50" }} /> : <Add style={{ color: "rgb(39 39 130)" }} />}
                        </Button>


                    </Box>
                    <Box sx={{ height: 'auto', width: "90%", marginBottom: "1rem", marginLeft: 6, overflow: "hidden" }}>
                        <table style={{ border: "1px groove #000", width: "100%" }}>
                            <thead>
                                <tr style={{ height: '40px', width: '90%', margin: '0', borderBottom: '1px solid black' }}>
                                    <th style={{ borderRight: "1px solid #000", borderBottom: "1px solid #000", padding: "8px" }}>Report Name</th>
                                    <th style={{ borderRight: "1px solid #000", borderBottom: '1px solid black', padding: "8px" }}>PMS Name</th>
                                    <th style={{ borderBottom: "1px solid #000", padding: "8px" }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.keys(tableData).length === 0 && (
                                    <tr>
                                        <td colSpan="3" style={{ padding: "8px", textAlign: "center" }}>
                                            Select PMS Name and Report Name from the dropdown
                                        </td>
                                    </tr>
                                )}

                                {/* ALERT MODULE ROWS */}
                                {Object.keys(tableData).filter(name => name === "Alert Processing").map((reportName, index) => (
                                    <tr key={`alert-${index}`} style={{ borderBottom: "1px solid #ddd", backgroundColor: isEditing === reportName ? "#fffde7" : "transparent" }}>
                                        <td style={{ padding: "8px", textAlign: "center", borderRight: "1px solid #ddd" }}>{reportName}</td>
                                        <td style={{ padding: "8px", textAlign: "left", overflowWrap: "break-word", maxWidth: "300px", borderRight: "1px solid #ddd",fontSize:"0.85rem" }}>
                                            {tableData[reportName].map(pmsItem => pmsItem.PMS).join(", ")}
                                        </td>
                                        <td style={{ padding: "8px", textAlign: "center" }}>
                                            <Box sx={{ display: "flex", justifyContent: "center", gap: "8px" }}>
                                                <Button style={{ height: '30px', minWidth: '40px', border: "1px solid #272782" }} onClick={() => handleDelete(reportName)}>
                                                    <Delete style={{ color: "rgb(39 39 130)", fontSize: '1.2rem' }} />
                                                </Button>
                                                <Button style={{ height: '30px', minWidth: '40px', border: "1px solid #272782" }} onClick={() => handleEdit(reportName)}>
                                                    <Edit style={{ color: "rgb(39 39 130)", fontSize: '1.2rem' }} />
                                                </Button>
                                            </Box>
                                        </td>
                                    </tr>
                                ))}

                                {Object.keys(tableData).includes("Alert Processing") && Object.keys(tableData).includes("CMM") && (
                                    <tr>
                                        <td colSpan="3" style={{ padding: "0px", height: "1px", backgroundColor: "#c0c0c0" }}></td>
                                    </tr>
                                )}

                                {/* CMM MODULE ROWS */}
                                {Object.keys(tableData).filter(name => name === "CMM").map((reportName, index) => (
                                    <tr key={`cmm-${index}`} style={{ borderBottom: "1px solid #ddd", backgroundColor: isEditing === reportName ? "#fffde7" : "transparent" }}>
                                        <td style={{ padding: "8px", textAlign: "center", borderRight: "1px solid #ddd" }}>{reportName}</td>
                                        <td style={{ padding: "8px", textAlign: "left", overflowWrap: "break-word", maxWidth: "300px", borderRight: "1px solid #ddd",fontSize:"0.85rem" }}>
                                            {tableData[reportName].map(pmsItem => pmsItem.PMS).join(", ")}
                                        </td>
                                        <td style={{ padding: "8px", textAlign: "center" }}>
                                            <Box sx={{ display: "flex", justifyContent: "center", gap: "8px" }}>
                                                <Button style={{ height: '30px', minWidth: '40px', border: "1px solid #272782" }} onClick={() => handleDelete(reportName)}>
                                                    <Delete style={{ color: "rgb(39 39 130)", fontSize: '1.2rem' }} />
                                                </Button>
                                                <Button style={{ height: '30px', minWidth: '40px', border: "1px solid #272782" }} onClick={() => handleEdit(reportName)}>
                                                    <Edit style={{ color: "rgb(39 39 130)", fontSize: '1.2rem' }} />
                                                </Button>
                                            </Box>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Box>


                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >
                    </Box>

                </Box>
                {userDetails ?
                    <Grid container justifyContent="center" sx={{ marginTop: "40px" }}>
                        <Grid container alignContent="flex-start" justifyContent="center">
                            <Button
                                variant="contained"
                                onClick={() => {
                                    if (validateFields(input)) {
                                        handleUpdate({
                                            firstName: input.firstName,
                                            lastName: input.lastName,
                                            mail: ls.get('edit_email'),
                                            user: { email: input.email, password: userDetails.user.password },
                                            userType: input.userType,
                                            division: input.division,
                                            "app.reports": tableData,
                                            userType: "SEBI",
                                            accountStatus: "Active",
                                        })
                                    }
                                }}
                                sx={{
                                    bgcolor: "#272782",
                                    mt: 1,
                                    width: "150px",
                                    borderRadius: "5px 5px 5px 5px",
                                    height: 40,
                                    fontFamily: "Roboto-Light",
                                    fontSize: "18px",
                                    lineHeight: "23px",
                                    display: "flex",
                                    align: "center",
                                    color: "#FFFFFF",
                                    margin: "0rem 0.5rem 0rem 0rem",
                                }}
                            >
                                <span style={{ fontSize: 14, fontWeight: 600 }}>Update</span>
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => { setOpen(true) }}
                                sx={{
                                    bgcolor: "#272782",
                                    mt: 1,
                                    borderRadius: "5px 5px 5px 5px",
                                    height: 40,
                                    fontFamily: "Roboto-Light",
                                    fontSize: "18px",
                                    lineHeight: "23px",
                                    display: "flex",
                                    align: "center",
                                    color: "#FFFFFF",
                                    margin: "0rem 0rem 0rem 0.5rem"
                                }}
                            >
                                <span style={{ fontSize: 14, fontWeight: 600 }}>Reset Password</span>
                            </Button>
                        </Grid>
                    </Grid>
                    :
                    <Grid container justifyContent="center" sx={{ marginTop: "16px" }}>
                        <Grid item xs={12} sm={6} md={4} lg={2.5}>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    if (validateFields(input)) {
                                        handleSubmit({ ...input, amcReportDetails: tableData });
                                        setInput(initialState);
                                        setTableData([]);
                                    }
                                }}
                                sx={{
                                    bgcolor: "#272782",
                                    width: "100%",
                                    borderRadius: "5px",
                                    height: 40,
                                    fontFamily: "Roboto-Light",
                                    fontSize: "18px",
                                    lineHeight: "23px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#FFFFFF",
                                }}
                            >
                                <span
                                    style={{
                                        fontSize: 14,
                                        fontWeight: 600,
                                    }}
                                >
                                    REGISTER
                                </span>
                            </Button>
                        </Grid>
                    </Grid>
                }
            </Box >
            {open && <EmailResetModal open={open} setOpen={setOpen} />}
        </Card >

    );
}

export default Sebi_Registration;